import { Modal } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import type { Dispatch, JSX, SetStateAction } from "react";

import Trans from "@/components/Trans/Trans";

import { Col, SpicyButton, Text } from "../customComponents";

type PermissionsModalProps = {
  isOpen: boolean;
  // This is an edge case when we get type directly from typescript

  permission: PermissionName;
  setIsPermissionsModal: Dispatch<SetStateAction<boolean>>;
  isDenied?: boolean;
};

function PermissionsModal({ isOpen = false, permission, setIsPermissionsModal, isDenied = false }: PermissionsModalProps): JSX.Element {
  const { t } = useTranslation();
  const Content = () => {
    if (permission === "microphone") {
      if (isDenied) {
        return (
          <Text>
            <Trans i18nKey="chat:modal.permissions.microphoneDenied" />
          </Text>
        );
      }
      return (
        <Text>
          <Trans i18nKey="chat:modal.permissions.microphoneRequest" values={{ permission }} components={{ b: <b /> }} />
        </Text>
      );
    } else {
      return (
        <Text>
          <Trans i18nKey="chat:modal.permissions.genericRequest" />
        </Text>
      );
    }
  };

  return (
    <Modal
      title={t("chat:modal.permissions.title")}
      classNames={{ title: "text-center pl-[28px]" }}
      open={isOpen}
      onOpenChange={setIsPermissionsModal}
    >
      <div className="text-center">
        <Content />
      </div>
      <Col align="center">
        <SpicyButton variant="primary" color="primary_strong" onPress={() => setIsPermissionsModal(false)}>
          <Trans i18nKey="chat:modal.permissions.cta.okay" />
        </SpicyButton>
      </Col>
    </Modal>
  );
}

export default PermissionsModal;
